import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { AppointmentsService } from 'src/app/appointments/services/appointments.service';
import { AppointmentStatuses, IAppointment, IDoctor } from 'src/app/appointments/types-and-const/appointment-types';

@Component({
  selector: 'app-archived',
  templateUrl: './archived.component.html',
  styleUrls: ['./archived.component.scss']
})
export class ArchivedComponent implements OnInit {
  public archivedAppointments: IAppointment[] = [];
  private userUid: string = this.localStorage.retrieve('loggedUser')['user_booking_uid'];

  @Input() doctorsData: Map<number, IDoctor>;

  constructor(
    private appointmentsService: AppointmentsService,
    private localStorage: LocalStorageService,
    private router: Router) { }

  ngOnInit(): void {
    this.getApprovedAppointments();
  }

  public getApprovedAppointments(): void {
    this.appointmentsService.getAppointmentsByStatus(this.userUid, AppointmentStatuses.ARCHIVED)
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.archivedAppointments = response;
          }
        },
        error: (err: any) => console.error(err),
        complete: () => { }
      })
  }

  public getDoctorInfo(doctorId: number, field: string): string | undefined {
    if (!doctorId) {
      return undefined;
    }

    let doctor = this.doctorsData.get(doctorId);

    return doctor?.[field];
  }

  public openAppointment(appointmentId: number) {
    this.router.navigate(['appointments/consultations/consultation/', appointmentId]);
  }

}
